import { useCallback, useEffect, useMemo } from 'react';
import isMacOs from 'automation-ui-canvas/components/flow-header/menu-bar/utils/isMacOs';
import { useGetHasScope, useGetIsUngated } from 'automation-ui-core/hooks/authHooks';
import { useLocation } from 'react-router-dom';
import { OPEN_QUERY_PARAM } from 'automation-ui-canvas/components/flow-header/menu-bar/MenuBar';
import { isActionConfigOpen as _isActionConfigOpen, isEnrollmentConfigOpen } from 'automation-ui-canvas/utils/routingUtils';
export const useShortcuts = ({
  flow,
  onOptionClick,
  shortcutOptions
}) => {
  const {
    search,
    pathname
  } = useLocation();
  const queryParams = new URLSearchParams(search);
  const isActionConfigOpen = _isActionConfigOpen({
    pathname
  }) || isEnrollmentConfigOpen({
    pathname
  });
  const isAnyPanelOpen = !!queryParams.get(OPEN_QUERY_PARAM) || isActionConfigOpen;
  const getShortcutHash = ({
    control = false,
    shift = false,
    option = false,
    key = ''
  }) => {
    const modifierHash = `${Number(control)}${Number(shift)}${Number(option)}`;
    return `${modifierHash}-${key.toLowerCase()}`;
  };
  const getIsUngated = useGetIsUngated();
  const getHasScope = useGetHasScope();
  const keyBoardShortcuts = useMemo(() => {
    let result = new Map();
    shortcutOptions.filter(option => {
      return !option.getIsVisible || option.getIsVisible({
        getIsUngated,
        getHasScope,
        isClassicWorkflow: flow.getIsClassicWorkflow(),
        flow
      });
    }).forEach(option => {
      let shortcuts;
      if (Array.isArray(option.shortcut)) {
        shortcuts = option.shortcut;
      } else {
        shortcuts = [option.shortcut];
      }
      shortcuts.forEach(shortcut => {
        result = result.set(getShortcutHash(shortcut), option.id);
      });
    });
    return result;
  }, [shortcutOptions, flow, getHasScope, getIsUngated]);
  const handleKeyPress = useCallback(event => {
    const hash = getShortcutHash({
      control: isMacOs() ? event.metaKey : event.ctrlKey,
      shift: event.shiftKey,
      option: event.altKey,
      key: event.key
    });
    const optionId = keyBoardShortcuts.get(hash);
    if (optionId) {
      var _shortcut$shortcutMod;
      const option = shortcutOptions.get(optionId);
      const shortcut = Array.isArray(option.shortcut) ? option.shortcut.find(maybeShortcut => hash === getShortcutHash(maybeShortcut)) : option.shortcut;
      const shortcutModeBlockList = (_shortcut$shortcutMod = shortcut === null || shortcut === void 0 ? void 0 : shortcut.shortcutModeBlockList) !== null && _shortcut$shortcutMod !== void 0 ? _shortcut$shortcutMod : [];
      const shouldBlockShortcut = shortcutModeBlockList.includes('action-config') && isActionConfigOpen || shortcutModeBlockList.includes('modal-any') && isAnyPanelOpen;
      if (shortcut && !shouldBlockShortcut) {
        event.preventDefault();
        onOptionClick(option, {
          isShortcut: true
        });
      }
    }
  }, [keyBoardShortcuts, shortcutOptions, onOptionClick, isActionConfigOpen, isAnyPanelOpen]);
  useEffect(() => {
    // attach the event listener
    document.addEventListener('keydown', handleKeyPress);

    // remove the event listener
    return () => document.removeEventListener('keydown', handleKeyPress);
  }, [handleKeyPress]);
};